import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppState } from '../../../reducers';
import { AcceptTermsAndConditionsAction, AcceptTermsAndConditionsSuccessAction } from '../auth.actions';

import { selectAuthUser } from '../auth.selectors';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { selectTermsAndConditions } from '../../../shared/layout/main.selectors';
import { User } from '../../administration/user/user.models';
import { printTermsAndConditions } from '../../../shared/utils';
import { ModalComponent } from 'atlas-modal';
import { Actions, DialogSizings } from 'atlas-cdk';

@Component({
  standalone: false,
  selector: 'dsp-terms-and-conditions',
  templateUrl: 'terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss'],

})
export class TermsAndConditionsComponent implements OnInit, AfterViewInit {

  @ViewChild(ModalComponent, { static: true })
  public termsModal: ModalComponent;

  public user$: Observable<User | undefined>;
  public terms$: Observable<string>;
  public modalSize: DialogSizings = DialogSizings.xlarge;

  public form: FormGroup;

  public constructor(
    private readonly store: Store<AppState>
  ) {
    this.user$ = this.store.pipe(select(selectAuthUser));
    this.terms$ = this.store.pipe(select(selectTermsAndConditions));
    this.form = new FormGroup({
      agreement: new FormControl(false, [Validators.requiredTrue])
    });
  }

  public ngOnInit(): void {
    this.user$.pipe(take(1)).subscribe(user => {
      if (user && user.settings && user.settings.optIns.terms) {
        this.store.dispatch(new AcceptTermsAndConditionsSuccessAction());
      }
    });
  }

  public ngAfterViewInit(): void {
    setTimeout(() => {
      this.termsModal.launch();
    }, 0);
  }

  public onAgree(): void {
    if (this.form.invalid || this.form.get('agreement')?.value !== true) {
      this.form.markAllAsTouched();
      return;
    }

    this.user$.pipe(take(1)).subscribe(user => {
      if (user) {
        this.store.dispatch(new AcceptTermsAndConditionsAction());
        this.termsModal.closeModal();
      }
    });
  }

  public onAgreementChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.form.get('agreement')?.setValue(!!input.checked);
  }

  public termsAndConditions(termsAndConditionDivId) {
    return printTermsAndConditions(termsAndConditionDivId);
  }
}
